module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [(_vm.loading) ? _c('div', [_vm._v(_vm._s(_vm.$t('generic.loading')) + "...")]) : _vm._e(), _vm._v(" "), (_vm.error) ? _c('div', {
    staticClass: "error"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('generic.calender')))])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('calendar-header', {
    attrs: {
      "current-month": _vm.currentMonth,
      "first-day": _vm.firstDay,
      "locale": _vm.appLocale
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "full-calendar-body"
  }, [_c('div', {
    staticClass: "weeks"
  }, _vm._l((7), function(dayIndex) {
    return _c('strong', {
      staticClass: "week"
    }, [_vm._v(_vm._s(_vm._f("weekDayName")((dayIndex - 1), _vm.firstDay, _vm.appLocale)))])
  })), _vm._v(" "), _c('div', {
    ref: "dates",
    staticClass: "dates"
  }, _vm._l((_vm.Weeks), function(week, index) {
    return _c('week', {
      key: index,
      attrs: {
        "firstDay": _vm.firstDay,
        "week": week
      }
    })
  }))])], 1)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ff4575d8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Calendar.vue
// module id = 145
// module chunks = 0 1